import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-multi-select-dropdown',
    templateUrl: './multi-select-dropdown.component.html',
    styleUrls: ['./multi-select-dropdown.component.css'],
})
export class MultiSelectDropdownComponent implements OnInit {
    @Input() items: Array<any> = []; // Accepts the list of items
    @Input() selectedItems: Array<any> = []; // Accepts the selected items
    @Output() selectedItemsChange = new EventEmitter<Array<any>>(); // Emits selected items on change
    @Output() checkvalidation = new EventEmitter<boolean>(); // Emits selected items on change
    @Output() resetDataOnclear = new EventEmitter<boolean>();
    @Input() selectedCountText: any;
    @Input() selectedBlankText: string = '';
    @Input() selectedProp: string = 'id';
    @Input() displayname: string = '';
    @Input() filterByLabel: string = '';
    @HostListener('document:click', ['$event'])
    onDocumentClick(event: MouseEvent) {
        // Check if the click is outside the dropdown
        if (!this.elementRef.nativeElement.contains(event.target)) {
            // if (this.dropdownOpen) {
            //     this.emitChanges();
            // }
            this.dropdownOpen = false;
        }
    }

    getSelectedMsg() {
        //alert(this.selectedItems);
        if (this.selectedItems.length > 0) {
            if (this.selectedItems.length <= 2) return this.selectedItems.map((item) => item.name);
            else return this.selectedCountText.replace('#count#', this.selectedItems.length.toLocaleString());
        } else {
            return this.selectedBlankText;
        }
    }
    constructor(private elementRef: ElementRef) {}
    searchTerm: string = '';
    dropdownOpen: boolean = false;

    ngOnInit(): void {
        console.log('the received name or label is', this.displayname);
    }

    get filteredItems() {
        if (this.filterByLabel == 'label') {
            return this.items.filter((item) => item.label.toLowerCase().startsWith(this.searchTerm.toLowerCase()));
        } else {
            return this.items.filter((item) => item.name.toLowerCase().startsWith(this.searchTerm.toLowerCase()));
        }
    }

    // toggleDropdown() {
    //     this.searchTerm = '';
    //     if (this.dropdownOpen) {
    //         this.emitChanges();
    //     }
    //     this.dropdownOpen = !this.dropdownOpen;
    // }

    toggleDropdown() {
        this.searchTerm = ''; // Clear the search term when opening the dropdown
        if (!this.dropdownOpen) {
            this.isSelectAll = this.isAllSelected(); // Validate "Select All" status
        }
        this.dropdownOpen = !this.dropdownOpen; // Toggle dropdown state
        this.checkvalidation.emit(true);
    }

    isAllSelected() {
        if (this.filteredItems.length === 0) {
            return false;
        }
        return this.filteredItems.every((item) => this.selectedItems.some((selectedItem) => selectedItem[this.selectedProp] === item[this.selectedProp]));
    }

    isSelectAll: boolean = false;

    toggleAllSelection() {
        if (this.filteredItems.length === 0) {
            this.isSelectAll = false; // Ensure it remains unchecked when no results
            return;
        }

        if (this.isSelectAll) {
            // Select only the filtered items
            this.selectedItems = [...new Set([...this.selectedItems, ...this.filteredItems])];
        } else {
            // Deselect only the filtered items
            this.selectedItems = this.selectedItems.filter(
                (selectedItem) => !this.filteredItems.some((filteredItem) => selectedItem[this.selectedProp] === filteredItem[this.selectedProp]),
            );
        }

        this.emitChanges();
    }

    isItemSelected(item: any) {
        return this.selectedItems.some((selectedItem) => selectedItem[this.selectedProp] === item[this.selectedProp]);
    }

    toggleItemSelection(item: any) {
        const index = this.selectedItems.findIndex((selectedItem) => selectedItem[this.selectedProp] === item[this.selectedProp]);
        if (index > -1) {
            this.selectedItems.splice(index, 1);
        } else {
            this.selectedItems.push(item);
        }
        this.emitChanges();
    }

    emitChanges() {
        this.selectedItemsChange.emit(this.selectedItems); // Emit updated selected items
    }

    clearList() {
        this.selectedItems = [];
        this.searchTerm = '';
        this.isSelectAll = false;
        this.emitChanges();
        this.resetDataOnclear.emit(true);
    }
}
